"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ScreenShareOutlined_1 = __importDefault(require("@material-ui/icons/ScreenShareOutlined"));
const StopScreenShareOutlined_1 = __importDefault(require("@material-ui/icons/StopScreenShareOutlined"));
const IconButton_1 = __importDefault(require("../IconButton"));
const styles_1 = __importDefault(require("./styles"));
const ScreenShareToggle = ({ id = 'screenshare', label, loading = false, value, onChange, }) => {
    const classes = styles_1.default({ value });
    return (react_1.default.createElement(IconButton_1.default, { id: id, label: label, disabled: loading, loading: loading, onClick: () => onChange(!value), ariaLabel: id },
        react_1.default.createElement("span", { className: classes.icon }, value ? react_1.default.createElement(ScreenShareOutlined_1.default, null) : react_1.default.createElement(StopScreenShareOutlined_1.default, null))));
};
exports.default = ScreenShareToggle;
